import NewShippingAddressFormState from "@bevco/Store/State/NewShippingAddress/NewShippingAddressFormState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: NewShippingAddressFormState = {
    address: {
        firstName: "",
        lastName: "",
        companyName: "",
        attention: "",
        address1: "",
        address2: "",
        address3: "",
        address4: "",
        city: "",
        postalCode: "",
        phone: "",
        email: "",
        fax: "",
    } as ShipToModel,
    formErrors: {},
    validations: {},
};

const reducer = {
    "Components/MyAccount/SetNewShippingAddress": (
        draft: Draft<NewShippingAddressFormState>,
        action: { address: ShipToModel },
    ) => {
        if (!draft.address) {
            return;
        }

        draft.address = action.address;
    },
    "Components/MyAccount/SetNewShippingAddressFormErrors": (
        draft: Draft<NewShippingAddressFormState>,
        action: { formErrors: { [key: string]: React.ReactNode } },
    ) => {
        if (!draft.formErrors) {
            return;
        }

        draft.formErrors = action.formErrors;
    },
    "Components/MyAccount/SetNewShippingAddressValidation": (
        draft: Draft<NewShippingAddressFormState>,
        action: { key: string; value: React.ReactNode },
    ) => {
        draft.formErrors[action.key] = action.value;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
